import * as React from 'react';
import { useState } from 'react';
import { alpha } from '@mui/material/styles';
import {
  Box,
  Stack,
  Typography,
  Button,
  TextField,
  Paper,
  Container,
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

export default function Photos(props) {
  const [selectedDate, setSelectedDate] = useState(null);

  const handleSubmit = () => {
    console.log('Scheduled Date:', selectedDate);
    // You can trigger backend update, notification, or confirmation here
  };

  return (
    <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' }, mx: 'auto' }}>
      <Typography variant="body1" sx={{ color: 'text.secondary', fontWeight: 600, mt: 2 }}>
        Photos and Video
      </Typography>
      <Box
        component="main"
        sx={(theme) => ({
          flexGrow: 1,
          backgroundColor: theme.vars
            ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
            : alpha(theme.palette.background.default, 1),
          overflow: 'auto',
          p: 3,
        })}
      >
        <Container maxWidth="md">
          <Box display="flex" justifyContent="center" alignItems="center">
            <Paper
              elevation={3}
              sx={{
                p: 4,
                borderRadius: 2,
                width: '100%',
                maxWidth: 700,
              }}
            >
              <Typography component="h2" variant="h4" gutterBottom align="center">
                Schedule Professional Property Photos
              </Typography>
              <Typography variant="body1" paragraph>
                Rocket Offer makes it easy to schedule professional photos and video of your property.
                Just select the date you’d like to schedule photos, and Rocket Offer will handle the details and email you a confirmation.
              </Typography>

              <Stack spacing={3} sx={{ mt: 2 }}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    label="Pick a date"
                    value={selectedDate}
                    onChange={(newValue) => setSelectedDate(newValue)}
                    renderInput={(params) => (
                      <TextField fullWidth {...params} />
                    )}
                  />
                </LocalizationProvider>

                <Button
                  variant="outlined"
                  onClick={handleSubmit}
                  disabled={!selectedDate}
                >
                  Submit
                </Button>
              </Stack>
            </Paper>
          </Box>
        </Container>
      </Box>
    </Box>
  );
}
